import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../components/customer/ewallet/ewallet.constants';
export var subscriberHasExternalGiftCardOfType = function subscriberHasExternalGiftCardOfType(allSubscriberPaymentMethods, externalGiftCardType) {
  var existingEGC = allSubscriberPaymentMethods.find(function (subscriberPaymentMethod) {
    if (String(subscriberPaymentMethod.Type) === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD) {
      return String(subscriberPaymentMethod.ExternalGiftCard.Type) === externalGiftCardType.Value;
    }
    return false;
  });
  return !!existingEGC;
};
export var isPaymentInstrumentTypeValueOptionSelected = function isPaymentInstrumentTypeValueOptionSelected(selectedPaymentInstrumentTypeValue, paymentInstrumentType, firstAcceptedPaymentInstrumentTypeCodeValue) {
  if (selectedPaymentInstrumentTypeValue) {
    return paymentInstrumentType.Value === selectedPaymentInstrumentTypeValue;
  }
  return "".concat(paymentInstrumentType.Value) === firstAcceptedPaymentInstrumentTypeCodeValue;
};